import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class ContactUsValidation {

    static async validate(form) {
        try {

            let validateForm = {
                sector: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                subject: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                message: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            };

            let validate = yup.object().shape(validateForm);

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }
}

export default ContactUsValidation;